import React from "react";

const Feature = () => {
  const featureArr = [
    {
      image: "/img/webpImg/Feature-one.webp",
      heading: "Get The Best Deals From Top Stores",
      subHeading:
        "Buy from top online stores, select popular categories and create your own customized deal groups.",
    },
    {
      image: "/img/webpImg/Feature-two.webp",
      heading: "Quick Deal Alerts On Your Phone",
      subHeading:
        "Get quick alerts about  best deals from all of your favorite stores with TBD’s powerful AI and never miss another deal.",
    },
    {
      image: "/img/webpImg/feature-three.webp",
      heading: "Price Graph To Find The Lowest Price",
      subHeading:
        "Save yourself from the uncertainty of product prices and find the best time to buy with TBD.",
    },
  ];

  return (
    <div className="items-center justify-between hidden sm:flex gap-y-10">
      <img
        src="/img/webpImg/tbd-offer.webp"
        alt="Feature image"
        className="w-[45%] shrink-0"
      />

      <div className="w-[45%] flex flex-col gap-2 md:gap-3 xl:gap-5">
        <h2 className="text-[#5254DB] text-[14px] md:text-[20px] leading-[100%] tracking-[1.1px] uppercase">
          Features
        </h2>

        <p className="text-[#000] text-[25px] md:text-[34px] font-semibold leading-[90%]">
          What’s Inside?
        </p>

        {featureArr.map((data, index) => (
          <div className="relative flex items-center">
            <img
              src={data.image}
              alt="Feature image"
              className="absolute w-[60px] md:w-[78px]"
            />
            <div className="bg-[#FAFAFA] py-[20px] md:py-[28px] px-[35px] md:px-[40px] rounded-[8px] flex flex-col gap-1.5 md:gap-2 ml-[10%] xl:ml-[8%]">
              <h3 className="text-[15px] md:text-[18px] font-semibold leading-[110%]">
                {data.heading}
              </h3>
              <p className="text-[12px] md:text-[14px] leading-[110%] ">
                {data.subHeading}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Feature;
